import './freeDownload.css'
import floralImg from '../../../../assets/img/libro/floral.png'
import SubHeading from '../../../subHeading/SubHeading'


const FreeDownload = () => {
  return (
    <section className="freeDownload">
      <div className="freeDownload__container section__padding">

        {/* TÍTULO */}
        <header className="freeDownload__header">
          <SubHeading title="Libre descarga" color={true} />
          <p className="freeDownload__subtitle">
            (Material disponible para uso educativo, comunitario y político.)
          </p>
        </header>

        {/* CONTENIDO */}
        <div className="freeDownload__content">

          {/* COLUMNA IZQUIERDA */}
          <a
            href="https://4bd89425.sibforms.com/serve/MUIFAHg1filMTzUWJKgvIu2uRPIIgemFEAGKi5IR1u5f65c5hfZT16O7lLkCdN7PKwyUJuZGsN4Ihke_2Ltb4ddE1O5geKY5rJ1U8TGJZU_CO5hbEaRuopC_A7eoZU4v959pcYS1kZd-KXWn_pzt5h5OZcj1ouvHi2SgcfUt2vQeHh0BITJhHbN7wMTcl4WKBTphKRNU8lV8BRm1"
            target="_blank"
            rel="noopener noreferrer"
            className="freeDownload__card freeDownload__card--left"
          >
            <div className="freeDownload__bubble">
              <h3>
                Capítulo <br />
                “La educadora menstrual”
              </h3>
            </div>
          </a>

          {/* CENTRO */}
          <div className="freeDownload__center">
            <img
              src={floralImg}
              alt="Transformando narrativas, erradicando estigmas"
            />
            <p className="freeDownload__centerText">
              Transformando narrativas,<br />
              erradicando estigmas.
            </p>
          </div>

          {/* COLUMNA DERECHA */}
          <a
            href={`${process.env.PUBLIC_URL}/pdfs/manifiesto.pdf`}
            download="Manifiesto-por-los-derechos-menstruales.pdf"
            className="freeDownload__card freeDownload__card--right"
          >
            <div className="freeDownload__bubble">
              <h3>
                Manifiesto por los <br />
                derechos menstruales
              </h3>
            </div>
          </a>

        </div>
      </div>
    </section>
  )
}

export default FreeDownload
